
import isNil from 'lodash/isNil';

import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.multiscene.multiscene.selectMode');

import getModeParams from './getModeParams';

export default function selectMode(viewer, modeId) {
    if (viewer) {
        let scene = viewer.getActualDimensionScene();
        if (scene) {
            let params = getModeParams(modeId);
            scene.setNavigationModeWithDataLayer(params.navigationMode);
            scene._spherePhotoDataLayer.setOpacity(params.spherePhotoOpacity);

            if (!isNil(params.pointCloudFreeze)) {
                scene.setPotreeFreeze(params.pointCloudFreeze);
            }
        }
    }
}
